import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductAdsBulkReviewModalComponent } from './product-ads-bulk-review-modal.component';
import { ForecastRxTreelistModule } from 'src/app/theme/shared/forecastui/forecast-rxtreelist/forecast-rxtreelist.module';
import { ButtonsModule, ChipModule } from '@progress/kendo-angular-buttons';

@NgModule({
  declarations: [ProductAdsBulkReviewModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ForecastRxTreelistModule,
    ButtonsModule,
    ChipModule
  ],
  exports: [ProductAdsBulkReviewModalComponent],
  entryComponents: [ProductAdsBulkReviewModalComponent],
})
export class ProductAdsBulkReviewModalModule {}
